import React, { Component } from "react";
import { Link } from "react-router-dom";
import AppDynamicFilterModal from "../../../partials/AppDynamicFilterModal";

export class AllPayoutsSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: {
        limit: 10,
        order_by: "updatedAt",
        order_direction: "DESC",
        page: 1,
      },
      openDrawer: false,
    };
    this.fields = [
      {
        name: "borrower_full_name",
        label: "Customer Name",
      },
      {
        name: "borrower_mobile_number",
        label: "Customer Mobile No.",
        type: "text",
      },
      {
        name: "application_status",
        label: "Application Status",
        type: "select",
        options: _enum.APPLICATION_STATUS,
      },
      {
        name: "application_product_type",
        label: "Product Type",
        type: "select",
        options: _enum.LOAN_TYPES,
      },
    ];

    this.isPanVerified = this.props.$store?.user?.is_pan_code_verified;
    this.isAadharVerified = this.props.$store?.user?.is_aadhar_verified;
    this.is_agreement_signed = this.props.$store?.user?.is_agreement_signed;
  }

  componentDidMount() {
    // this.getBankNames();
  }

  getBankNames = () => {
    let payload = {
      page: 1,
    };
    this.props.apis.apiGetBanknames(payload).then((data) => {
      console.log({ apiGetBanknames: data });
      let textField = this.fields;
      let bankNameField = textField.find((o) => o.name === "bankName");
      bankNameField.options = data;
      this.setState([...textField]);
    });
  };

  toggleDrawer = () => {
    this.setState((prev) => ({ openDrawer: !prev.openDrawer }));
  };

  closeDrawer = () => {
    this.setState({ openDrawer: false });
  };

  onSearch = (formData) => {
    let data = Object.filter(formData, (val) => val);
    this.props.onSearch && this.props.onSearch(data, false);
  };

  onReset = (formData, reset) => {
    let data = Object.filter(formData, (val) => val);
    this.props.onSearch && this.props.onSearch(data, reset);
  };

  render() {
    let { openDrawer } = this.state;
    const adminPersona =
      this.props?.$store?.user?.role === _enum.ROUTE_PERSONAS.admin;
    return (
      <>
        <button
          type="button"
          className="btn filter_modal_btn"
          onClick={(...args) => this.toggleDrawer(...args)}
        >
          <i class="fa-solid fa-filter me-2"></i>
          <span>Filters</span>
        </button>
        <AppDynamicFilterModal
          open={openDrawer}
          onClose={this.closeDrawer}
          fields={this.fields}
          onSearch={this.onSearch}
          onReset={this.onReset}
        />
      </>
    );
  }
}

export default constore(AllPayoutsSearch);
